<template>
  <div class="view view-inspector">
    <transition name="view__sidebartransition">
      <side-bar
        v-if="!sidebarClosed"
      >
        <inspector-matrix-menu v-if="subview == 'matrix'" />
        <inspector-ways-menu v-if="subview == 'ways'" />
      </side-bar>
    </transition>
    <div class="main">
      <tab-bar
        :active="subview"
        :views="{
          matrix: $t('labels.crossImpactMatrix'),
          ways: $t('objectNames.impactChain', 2)
        }"
        @choose="chooseSubview"
      />
      <inspector-net />
      <simulation-progress-bar
        v-if="simulationBarVisible"
        :content-height="state.contentHeight"
        :hide-invisibles="true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed, onMounted } from "vue";
import { onBeforeRouteLeave } from "vue-router";

import SideBar from "@core/ui/SideBar.vue";
import TabBar from "@editor/components/TabBar.vue";

import InspectorMatrixMenu from "@editor/views/inspector/menus/InspectorMatrixMenu.vue";
import InspectorWaysMenu from "@editor/views/inspector/menus/InspectorWaysMenu.vue";
import InspectorNet from "@editor/views/inspector/InspectorNet.vue";

import SimulationProgressBar from "@editor/items/simulation/SimulationProgressbar.vue";

import { useInspectorView } from "@editor/views/inspector/inspectorView.store";
import { useWayStore } from "@editor/items/way/ways.store";
import { useNetStore } from "@editor/net/net.store";

defineOptions({
  name: "InspectorView",
});

const netStore = useNetStore();

onBeforeRouteLeave((to, from, next) => {
  // no way should be active when leaving this view.
  if (activeWayId.value != null) {
    activeWayId.value = null;
  }
  // hide all element value modifications
  const inspectorView = useInspectorView();
  inspectorView.hideAllTargetValueChanges();
  next();
});

const state = reactive({ contentHeight: 0 });

const activeWayId = computed({
  get() {
    return useWayStore().activeId;
  },
  set(value: number | null) {
    useWayStore().setActive(value);
  }
});

const subview = computed(() => {
  const inspectorView = useInspectorView();
  return inspectorView.subview;
});

const simulationBarVisible = computed(() => {
  return subview.value == "matrix";
});

function chooseSubview(view: "matrix" | "ways") {
  const inspectorView = useInspectorView();
  inspectorView.set({
    subview: view
  });
}

const sidebarClosed = computed(() => netStore.sidebarClosed);

function updateContentHeight() {
  const netElement = document.querySelector<HTMLElement>(".net__container");
  if (netElement) {
    state.contentHeight = netElement.offsetHeight - 30;
  }
  //this.contentHeight = this.$refs.net.$el.offsetHeight - 30;
}

onMounted(() => {
  updateContentHeight();
});
</script>

<style lang="scss">
.view-inspector {
  background-color: var(--color-background-deeper);
}
</style>
